// Campo que acha o cliente pelo telefone e abre o pedido de entrega.
// Também é por aqui que se cadastra endereço novo.
import React from "react";
import { DadosDoPedido } from "../../../../store/Slices/orderSlice";
import * as Styles from "../../styles/PointOfSale.styles";

export const BuscaDeClientePorTelefone: React.FC<{
  component: any;
  componentProps: any;
  buttonLabel: any;
  searchValueInput: string;
  setSearchValueInput: (valor: string) => void;
  searchInputRefType3: React.RefObject<HTMLInputElement>;
  handleSearch: (openNewOrder?: boolean, productExpanded?: boolean) => void;
  setComponent: () => void;
  customerInfoByOrder: any;
  orderDataZustand: DadosDoPedido;
  setCurrentModalOpen: (nome: string) => void;
  setCustomerAddressToUpdate: (endereco: any) => void;
  setMessageZustand: (mensagem: string, tipo: string) => void;
}> = ({
  component,
  componentProps,
  buttonLabel,
  searchValueInput,
  setSearchValueInput,
  searchInputRefType3,
  handleSearch,
  setComponent,
  customerInfoByOrder,
  orderDataZustand,
  setCurrentModalOpen,
  setCustomerAddressToUpdate,
  setMessageZustand,
}) => {
  return (
    <Styles.Search
      selected={Boolean(component.componentSelected)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
      componentHeight={String(componentProps.componentHeight)}
      componentWidth={String(componentProps.componentWidth)}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.SearchInput
        ref={searchInputRefType3}
        id={component.componentId}
        componentWidth={"30%"}
        defaultValue={searchValueInput}
        onChange={(e) => {
          // Permite apenas números, espaços e caracteres especiais comuns de telefone
          const value = e.target.value.replace(/[^0-9\s\-()+]/g, "");
          setSearchValueInput(value);
        }}
        onBlur={() => {
          setComponent();
        }}
        placeholder={String(componentProps.componentInputPlaceholder)}
        onKeyDown={(e) => {
          // Permite teclas de controle (backspace, delete, setas, tab, etc)
          if (
            !(
              (e.key >= "0" && e.key <= "9") ||
              ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " ", "(", ")", "+", "-"].includes(e.key)
            )
          ) {
            e.preventDefault();
          }
        }}
      />
      <Styles.SearchButton
        componentWidth={"20%"}
        componentBackgroundColor={String(
          componentProps.componentBackgroundColor
        )}
        onClick={() => {
          if (searchValueInput === "") {
            setCurrentModalOpen("CustomerModal");
          }
          else {
            handleSearch();
          }
        }}
      >
        <Styles.SearchIcon>search</Styles.SearchIcon>
        {componentProps.componentShortcut !== "" ? (
          <>
            <span className="buttonLabel">Buscar</span>
            <Styles.Divider orientation={"vertical"} />
            <span className="shortcut">
              {componentProps.componentShortcut}
            </span>
          </>
        ) : (
          <>
            <span className="buttonLabel">Buscar</span>
          </>
        )}
      </Styles.SearchButton>
      <Styles.SearchButton
        componentWidth={"20%"}
        componentBackgroundColor={String(
          componentProps.componentBackgroundColor
        )}
        onClick={() => {
          if (orderDataZustand.orderUuid === "") {
            if (searchValueInput === "") {
              setCurrentModalOpen("CustomerModal");
            } else {
              handleSearch();
            }
          } else if (orderDataZustand.orderUuid !== "" && orderDataZustand.orderStatus === 0) {
            setMessageZustand(`Cancele ou confirme a conta em preenchimento.`, `error`);
          }
          else {
            setCurrentModalOpen("CustomerModal");
          }
        }}
      >
        <Styles.SearchIcon>search</Styles.SearchIcon>
        {componentProps.componentShortcut !== "" ? (
          <>
            <span className="buttonLabel">Procurar</span>
            <Styles.Divider orientation={"vertical"} />
            <span className="shortcut">
              {`control + ${componentProps.componentShortcut}`}
            </span>
          </>
        ) : (
          <>
            <span className="buttonLabel">Buscar</span>
          </>
        )}
      </Styles.SearchButton>
      <Styles.SearchButton
        componentWidth={"20%"}
        componentBackgroundColor={String(
          componentProps.componentBackgroundColor
        )}
        onClick={() => {
          if (
            !customerInfoByOrder.customerAddress ||
            customerInfoByOrder.customerAddress.trim() === ""
          ) {
            setMessageZustand(`Selecione um endereço para atualizar.`, `error`);
          } else {
            setCustomerAddressToUpdate({
              customerUuid: orderDataZustand.orderInfo.customerUuid || "",
              customerOrigin: customerInfoByOrder.customerOrigin || "",
              customerAddress: customerInfoByOrder.customerAddress || "",
              customerName: customerInfoByOrder.customerName || "",
              customerPhone: customerInfoByOrder.customerPhone || "",
              customerAddressComplement: customerInfoByOrder.customerAddressComplement || "",
              customerAddressObservation: customerInfoByOrder.customerAddressObservation || "",
            });
            setCurrentModalOpen("UpdateCustomerAddressModal");
          }
        }}
      >
        <Styles.SearchIcon>search</Styles.SearchIcon>
        {componentProps.componentShortcut !== "" ? (
          <>
            <span className="buttonLabel">Atualizar</span>
            <Styles.Divider orientation={"vertical"} />
            <span className="shortcut">
              {`shift + ${componentProps.componentShortcut}`}
            </span>
          </>
        ) : (
          <>
            <span className="buttonLabel">Atualizar</span>
          </>
        )}
      </Styles.SearchButton>
    </Styles.Search>
  );
};
